import { LoadingButton } from '@mui/lab';
import { Checkbox, TextField, InputAdornment, Button, FormGroup, FormControlLabel, AppBar, Box, IconButton, Toolbar, Typography, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse, Tabs, Tab, Autocomplete, Paper, Stepper, Step, StepLabel, MenuItem, Alert, Snackbar, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Menu, Avatar, Divider, Popover, Switch, Badge, Tooltip, InputLabel, Select, OutlinedInput, Chip, Grid, Card, CardContent, CardHeader, FormControl } from '@mui/material';

const Components = {
  Avatar,
  TextField,
  Divider,
  Autocomplete,
  InputAdornment,
  Button,
  Checkbox,
  Chip,
  FormGroup, FormControlLabel,
  InputLabel,
  Select,
  OutlinedInput,
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Tabs,
  Tab,
  Paper,
  Stepper,
  Step,
  StepLabel,
  MenuItem,
  Alert,
  Snackbar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LoadingButton,
  Menu,
  Popover,
  Switch,
  Badge,
  Tooltip,
  Grid,
  Card,
  CardContent,
  CardHeader,
  FormControl
};

export default Components;
